export default {
  english: [
    [
      {
        sentenceIdentifier: 1,
        sentence:
          "On the 25th March, 18—, a very strange occurrence took place in St Petersburg. "
      },
      {
        sentenceIdentifier: 2,
        sentence:
          "On the Ascension Avenue there lived a barber of the name of Ivan Jakovlevitch. "
      },
      {
        sentenceIdentifier: 3,
        sentence: "He had lost his family name, and on his sign-board, "
      },
      {
        sentenceIdentifier: 4,
        sentence:
          "on which was depicted the head of a gentleman with one cheek soaped, the only inscription to be read was, “Blood-letting done here.”"
      },
      {
        sentenceIdentifier: 5,
        sentence:
          "On this particular morning he awoke pretty early. Becoming aware of the smell of fresh-baked bread, "
      },
      {
        sentenceIdentifier: 6,
        sentence:
          "he sat up a little in bed, and saw his wife, who had a special partiality for coffee, "
      },
      {
        sentenceIdentifier: 7,
        sentence: "in the act of taking some fresh-baked bread out of the oven."
      }
    ],
    [
      { sentenceIdentifier: 8, sentence: "---" },
      {
        sentenceIdentifier: 9,
        sentence: "“To-day, Prasskovna Ossipovna,” he said, "
      },
      {
        sentenceIdentifier: 10,
        sentence:
          "“I do not want any coffee; I should like a fresh loaf with onions.”"
      }
    ],
    [
      { sentenceIdentifier: 11, sentence: "---" },
      { sentenceIdentifier: 12, sentence: "" },
      {
        sentenceIdentifier: 13,
        sentence:
          "“The blockhead may eat bread only as far as I am concerned,” said his wife to herself; "
      },
      {
        sentenceIdentifier: 14,
        sentence: "“then I shall have a chance of getting some coffee.” "
      },
      {
        sentenceIdentifier: 15,
        sentence: "And she threw a loaf on the table."
      }
    ],
    [
      { sentenceIdentifier: 16, sentence: "---" },
      {
        sentenceIdentifier: 17,
        sentence:
          "For the sake of propriety, Ivan Jakovlevitch drew a coat over his shirt, sat down at the table, shook out some salt for himself, prepared two onions, assumed a serious expression, and began to cut the bread. "
      },
      {
        sentenceIdentifier: 18,
        sentence:
          "After he had cut the loaf in two halves, he looked, and to his great astonishment saw something whitish sticking in it. "
      },
      {
        sentenceIdentifier: 19,
        sentence:
          "He carefully poked round it with his knife, and felt it with his finger."
      },
      {
        sentenceIdentifier: 20,
        sentence:
          "“Quite firmly fixed!” he murmured in his beard. “What can it be?”"
      }
    ],
    [
      { sentenceIdentifier: 21, sentence: "---" },
      {
        sentenceIdentifier: 22,
        sentence: "He put in his finger, and drew out—a nose!"
      },
      {
        sentenceIdentifier: 23,
        sentence:
          "Ivan Jakovlevitch at first let his hands fall from sheer astonishment; "
      },
      {
        sentenceIdentifier: 24,
        sentence:
          "then he rubbed his eyes and began to feel it. A nose, an actual nose; "
      },
      {
        sentenceIdentifier: 25,
        sentence: "and, moreover, it seemed to be the nose of an acquaintance! "
      },
      {
        sentenceIdentifier: 26,
        sentence: "Alarm and terror were depicted in Ivan's face; "
      },
      {
        sentenceIdentifier: 27,
        sentence:
          "but these feelings were slight in comparison with the disgust which took possession of his wife."
      }
    ],
    [
      { sentenceIdentifier: 28, sentence: "---" },
      {
        sentenceIdentifier: 29,
        sentence:
          "“Whose nose have you cut off, you monster?” she screamed, her face red with anger. "
      },
      {
        sentenceIdentifier: 30,
        sentence:
          "“You scoundrel! You tippler! I myself will report you to the police! Such a rascal! "
      },
      {
        sentenceIdentifier: 31,
        sentence:
          "Many customers have told me that while you were shaving them, you held them so tight by the nose that they could hardly sit still.”"
      }
    ],
    [
      { sentenceIdentifier: 32, sentence: "---" },
      {
        sentenceIdentifier: 33,
        sentence: "But Ivan Jakovlevitch was more dead than alive; "
      },
      {
        sentenceIdentifier: 34,
        sentence:
          "he saw at once that this nose could belong to no other than to Kovaloff, a member of the Municipal Committee whom he shaved every Sunday and Wednesday."
      }
    ],
    [
      { sentenceIdentifier: 35, sentence: "---" },
      {
        sentenceIdentifier: 36,
        sentence:
          "“Stop, Prasskovna Ossipovna! I will wrap it in a piece of cloth and place it in the corner. "
      },
      {
        sentenceIdentifier: 37,
        sentence:
          "There it may remain for the present; later on I will take it away.”"
      }
    ],
    [
      { sentenceIdentifier: 38, sentence: "---" },
      { sentenceIdentifier: 39, sentence: "“No, not there! " },
      {
        sentenceIdentifier: 40,
        sentence: "Shall I endure an amputated nose in my room? "
      },
      {
        sentenceIdentifier: 41,
        sentence: "You understand nothing except how to strop a razor. "
      },
      {
        sentenceIdentifier: 42,
        sentence:
          "You know nothing of the duties and obligations of a respectable man. You vagabond! You good-for-nothing! "
      },
      {
        sentenceIdentifier: 43,
        sentence:
          "Am I to undertake all responsibility for you at the police-office? Ah, you soap-smearer! You blockhead! "
      },
      {
        sentenceIdentifier: 44,
        sentence:
          "Take it away where you like, but don't let it stay under my eyes!”"
      }
    ]
  ],
  russian: [
    [
      {
        sentenceIdentifier: 1,
        sentence:
          "Марта 25 числа случилось в Петербурге необыкновенно странное происшествие. "
      },
      {
        sentenceIdentifier: 2,
        sentence: "Цирюльник Иван Яковлевич, живущий на Вознесенском проспекте "
      },
      {
        sentenceIdentifier: 3,
        sentence: "(фамилия его утрачена, и даже на вывеске его — "
      },
      {
        sentenceIdentifier: 4,
        sentence:
          "где изображен господин с намыленною щекою и надписью: «И кровь отворяют» — не выставлено ничего более), "
      },
      {
        sentenceIdentifier: 5,
        sentence:
          "цирюльник Иван Яковлевич проснулся довольно рано и услышал запах горячего хлеба. "
      },
      {
        sentenceIdentifier: 6,
        sentence:
          "Приподнявшись немного на кровати, он увидел, что супруга его, довольно почтенная дама, очень любившая пить кофий, "
      },
      {
        sentenceIdentifier: 7,
        sentence: "вынимала из печи только что испеченные хлебы."
      }
    ],
    [
      { sentenceIdentifier: 8, sentence: "---" },
      {
        sentenceIdentifier: 9,
        sentence:
          "— Сегодня я, Прасковья Осиповна, не буду пить кофию, — сказал Иван Яковлевич, "
      },
      {
        sentenceIdentifier: 10,
        sentence: "— а вместо того хочется мне съесть горячего хлебца с луком."
      }
    ],
    [
      { sentenceIdentifier: 11, sentence: "---" },
      {
        sentenceIdentifier: 12,
        sentence:
          "(То есть Иван Яковлевич хотел бы и того и другого, но знал, что было совершенно невозможно требовать двух вещей разом, ибо Прасковья Осиповна очень не любила таких прихотей.) '"
      },
      {
        sentenceIdentifier: 13,
        sentence:
          "«Пусть дурак ест хлеб; мне же лучше, — подумала про себя супруга, "
      },
      {
        sentenceIdentifier: 14,
        sentence: "— останется кофию лишняя порция». "
      },
      {
        sentenceIdentifier: 15,
        sentence: "И бросила один хлеб на стол."
      }
    ],
    [
      { sentenceIdentifier: 16, sentence: "---" },
      {
        sentenceIdentifier: 17,
        sentence:
          "Иван Яковлевич для приличия надел сверх рубашки фрак и, усевшись перед столом, насыпал соль, приготовил две головки луку, взял в руки нож и, сделавши значительную мину, принялся резать хлеб. "
      },
      {
        sentenceIdentifier: 18,
        sentence:
          "Разрезавши хлеб на две половины, он поглядел в середину и, к удивлению своему, увидел что-то белевшееся. "
      },
      {
        sentenceIdentifier: 19,
        sentence: "Иван Яковлевич ковырнул осторожно ножом и пощупал пальцем. "
      },
      {
        sentenceIdentifier: 20,
        sentence:
          "«Плотное! — сказал он сам про себя, — что бы это такое было?»"
      }
    ],
    [
      { sentenceIdentifier: 21, sentence: "---" },
      {
        sentenceIdentifier: 22,
        sentence: "Он засунул пальцы и вытащил — нос!.. "
      },
      {
        sentenceIdentifier: 23,
        sentence: "Иван Яковлевич и руки опустил; "
      },
      {
        sentenceIdentifier: 24,
        sentence: "стал протирать глаза и щупать: нос, точно нос! "
      },
      {
        sentenceIdentifier: 25,
        sentence: "и еще, казалось, как будто чей-то знакомый. "
      },
      {
        sentenceIdentifier: 26,
        sentence: "Ужас изобразился в лице Ивана Яковлевича. "
      },
      {
        sentenceIdentifier: 27,
        sentence:
          "Но этот ужас был ничто против негодования, которое овладело его супругою."
      }
    ],
    [
      { sentenceIdentifier: 28, sentence: "---" },
      {
        sentenceIdentifier: 29,
        sentence: "— Где это ты, зверь, отрезал нос? — закричала она с гневом. "
      },
      {
        sentenceIdentifier: 30,
        sentence:
          "— Мошенник! пьяница! Я сама на тебя донесу полиции. Разбойник какой! "
      },
      {
        sentenceIdentifier: 31,
        sentence:
          "Вот уж я от трех человек слышала, что ты во время бритья так теребишь за носы, что еле держатся."
      }
    ],
    [
      { sentenceIdentifier: 32, sentence: "---" },
      {
        sentenceIdentifier: 33,
        sentence: "Но Иван Яковлевич был ни жив ни мертв. "
      },
      {
        sentenceIdentifier: 34,
        sentence:
          "Он узнал, что этот нос был не чей другой, как коллежского асессора Ковалева, которого он брил каждую середу и воскресенье."
      }
    ],
    [
      { sentenceIdentifier: 35, sentence: "---" },
      {
        sentenceIdentifier: 36,
        sentence:
          "— Стой, Прасковья Осиповна! Я положу его, завернувши в тряпку, в уголок; "
      },
      {
        sentenceIdentifier: 37,
        sentence: "пусть там маленечко полежит, а после его вынесу."
      }
    ],
    [
      { sentenceIdentifier: 38, sentence: "---" },
      { sentenceIdentifier: 39, sentence: "— И слушать не хочу! " },
      {
        sentenceIdentifier: 40,
        sentence:
          "Чтобы я позволила у себя в комнате лежать отрезанному носу?.. Сухарь поджаристый! "
      },
      {
        sentenceIdentifier: 41,
        sentence: "Знай умеет только бритвой возить по ремню, "
      },
      {
        sentenceIdentifier: 42,
        sentence:
          "а долга своего скоро совсем не в состоянии будет исполнять, потаскушка, негодяй! "
      },
      {
        sentenceIdentifier: 43,
        sentence:
          "Чтобы я стала за тебя отвечать полиции?.. Ах ты, пачкун, бревно глупое! "
      },
      {
        sentenceIdentifier: 44,
        sentence: "Вон его! вон! неси куда хочешь! чтобы я духу его не слыхала!"
      }
    ]
  ]
};
